import classes from "./spinnerInner.module.scss"

function SpinnerInner() {
  return (
    <div className={classes.imageSpinner} />
  )
}

export default SpinnerInner;
